import { asDetail, blockLines, sumLines } from './line-groups'
import type { DetailRow, LineBlock } from './line-groups'
import type { ReportRow } from './components/report-table'
import type { InvoiceLine } from './types'

/** How the lines are read: what sold, or what it earned over what it cost. */
export const DetailReading = {
  Sales: 'sales',
  Profit: 'profit',
} as const

export type DetailReading = (typeof DetailReading)[keyof typeof DetailReading]

/**
 * Block → item → the invoices it sold on, each with a subtotal, then the
 * period. `block` null starts at the items.
 */
export function itemDetailRows(
  lines: InvoiceLine[],
  block: LineBlock | null,
): { rows: ReportRow<DetailRow>[]; total: DetailRow } {
  const rows: ReportRow<DetailRow>[] = []

  for (const [blockIndex, entry] of blockLines(lines, block).entries()) {
    const key = `${blockIndex}:${entry.name}`

    if (block) rows.push({ id: `${key}:head`, data: null, label: entry.name, tone: 'group' })

    for (const [itemIndex, item] of entry.items.entries()) {
      const itemKey = `${key}:${itemIndex}`

      rows.push({ id: `${itemKey}:head`, data: null, label: item.name, tone: 'group' })
      rows.push(
        ...item.lines.map((line, index) => ({ id: `${itemKey}:${index}`, data: asDetail(line) })),
      )
      rows.push({
        id: `${itemKey}:subtotal`,
        data: sumLines(item.lines),
        label: `${item.name} total`,
        tone: 'subtotal',
      })
    }

    if (block) {
      rows.push({
        id: `${key}:subtotal`,
        data: sumLines(entry.lines),
        label: `${entry.name} total`,
        tone: 'subtotal',
      })
    }
  }

  return { rows, total: sumLines(lines) }
}
